import { useLoadContainers } from "../../components/containers/hooks/useContainers";
import ContainerConnectionForm from "./ContainerConnectionForm";

export default function ContainerList() {
  const { containersRes } = useLoadContainers();

  console.log("containersRes", containersRes?.containers);

  return (
    <div>
      {containersRes &&
        containersRes.count > 0 &&
        containersRes?.containers?.map((item) => {
          const wsUrl = `ws://localhost:8080/ws/api-service-${item.name}`;
          console.log("wsUrl", wsUrl);

          return (
            <div key={item.id} className="flex flex-col gap-10">
              <div key={item.id} className="flex flex-row gap-2">
                <p>{item.name}</p>
                <p>{item.status}</p>
                <p>{item.workingRepo.value}</p>
                <p>{wsUrl}</p>
              </div>
              <ContainerConnectionForm url={wsUrl} />
            </div>
          );
        })}
    </div>
  );
}
